import React, { useState } from "react";
import Notice from "../Notice";
import AddTpaButton from "./AddTpaButton";
import TpaPermission from "./TpaPermission";
import EntityInfo from "./EntityInfo";
import Http from "./http";

const TpaPermissionsIndex = (props) => {
  const [entities, setEntities] = useState(props.entities);
  const [notice, setNotice] = useState({
    kind: "error",
    open: false,
    message: "",
  });

  const http = new Http(props.path, setEntities, setNotice);

  const renderPermissions = (entity) => {
    return entity.permissions.map((permission) => {
      return (
        <TpaPermission
          key={permission.id}
          canUpdate={entity.can_update}
          entityName={entity.entity_name}
          id_340b={entity.id_340b}
          tpaName={permission.tpa_name}
          eligibilityRole={permission.eligibility_role}
          submissionRole={permission.submission_role}
          handleDelete={() => http.deletePermission(permission.id, entity.id_340b)}
        />
      );
    });
  };

  const renderForm = () => {
    return entities.map((entity) => {
      return (
        <div className="entity__tpa__container" key={entity.id_340b}>
          <div className="entity__container flex gap--24 mb--8">
            <EntityInfo
              id_340b={entity.id_340b}
              name={entity.entity_name}
              terminated={entity.terminated}
            />
            {entity.can_update && (
              <AddTpaButton entity={entity} submitPermission={http.submitPermission} />
            )}
          </div>
          <div className="tpas_container">{renderPermissions(entity)}</div>
        </div>
      );
    });
  };

  const renderAccessTokenDetails = () => (
    <div className="card__details__section__note" style={{ marginBottom: 30 }}>
      To allow your TPA to submit claims data and view eligibility details for your Covered Entity,
      enter their <strong>340B ESP Access Token</strong> below. Your TPA should provide you with
      this token. Once you have it, add it here to give them access.
    </div>
  );

  return (
    <div>
      <div className="card__details__section__title">TPA Access Tokens</div>
      {renderAccessTokenDetails()}
      {renderForm()}
      <Notice details={notice} />
    </div>
  );
};

export default TpaPermissionsIndex;
